/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import { SkeletonBlock } from "components/general/Skeleton";
import { useIsTradeHistoryReturned } from "hooks/useIsTradeHistoryReturned";
import React from "react";

export interface TotalAmountTradedCellProps {
  totalAmountTraded: string;
}

export const TotalAmountTradedCell: React.FC<TotalAmountTradedCellProps> = ({
  totalAmountTraded,
}) => {
  const isTradeHistoryReturned = useIsTradeHistoryReturned();
  return (
    <TotalAmountTradedContainer>
      {isTradeHistoryReturned ? `$${totalAmountTraded}` : <SkeletonBlock width={44} />}
    </TotalAmountTradedContainer>
  );
};

// Sub-components

const TotalAmountTradedContainer = styled.div`
  text-align: right;
  font-size: ${props => props.theme.fontSize["5"]};
`;
